import i18n from "../resources/I18n";
import Configuration from "../Configuration";
import { Purify } from "./PurifyTexte";
import * as TYPE_PROJET from "../constants/typeprojet";

function obtenirUrlClickToCallMobile(typeProjet?: string) {
  const isAMC = typeProjet === TYPE_PROJET.AMC;
  const configs = Configuration.obtenirConfigurations();

  let urlClickToCallMobile: string;

  if (i18n.language === "en") {
    urlClickToCallMobile = isAMC
      ? configs.urlClickToCallMobileEN_AMC
      : configs.urlClickToCallMobileEN;
  } else {
    urlClickToCallMobile = isAMC
      ? configs.urlClickToCallMobileFR_AMC
      : configs.urlClickToCallMobileFR;
  }

  return urlClickToCallMobile;
}

function obtenirUrlClickToCallDesktop(typeProjet?: string) {
  const isAMC = typeProjet === TYPE_PROJET.AMC;
  const configs = Configuration.obtenirConfigurations();

  let urlClickToCallDesktop: string;

  if (i18n.language === "en") {
    urlClickToCallDesktop = isAMC
      ? configs.urlClickToCallDesktopEN_AMC
      : configs.urlClickToCallDesktopEN;
  } else {
    urlClickToCallDesktop = isAMC
      ? configs.urlClickToCallDesktopFR_AMC
      : configs.urlClickToCallDesktopFR;
  }

  return urlClickToCallDesktop;
}

export function obtenirURLClickToCall(noDemande: string, transit: string, raisonSortie: string, destination: string, typeProjet?: string) {

  let baseUrl;

  if (window.innerWidth >= 480) {

    baseUrl = obtenirUrlClickToCallDesktop(typeProjet)

  } else {

    baseUrl = obtenirUrlClickToCallMobile(typeProjet)
  }

  const url = encodeURIComponent(Purify(window.location.href));
  const struct = ["VPA", "DPCCCSC", "Financement"];

  return `${baseUrl}?struct=${encodeURI(JSON.stringify(struct))}&dest=${destination}&da=P&source=${url}&MVT_REFERENCE_EXTERNE=${Purify(
    noDemande
  )}&MVT_TYPE_REFERENCE_EXTERNE=Numero ID Demande&MVT_CONTEXTE=Assurance&MVT_URL=${url}&MVT_RAISON_SORTIE=${raisonSortie} ${Purify(
    transit
  )}&MVT_LANGUE=${i18n.language}`;
}
